import { ADD_PERMISSIONS } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case ADD_PERMISSIONS:
      return action.payload
    default:
      return state
  }
}
